import React from 'react';
import { getAuthToken, getUserDetail, removeAllCookies } from './../../utils';
import CONSTANT from './../../constant';
import { removeSessionHistoryData } from '../../actions/AuthAction';
import constant from './../../constant';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class Logout extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
       
    }


    componentDidMount() {
        document.title = CONSTANT.pageTitle.logout;


        let ud = getUserDetail()

        if(ud!=undefined) 
                this.removeSessionHistory(ud.code)
        
     }

      
     removeSessionHistory(userCode:Number) {
        
         removeSessionHistoryData(userCode).then((res:any)=>{
            if(res.status==constant.static.apiStatus.success) {
                removeAllCookies();
                localStorage.removeItem('timer')
                window.location.pathname="/"
                // this.props.history.push('/');   
        }
        }).catch((err:any)=>{
            toast.error("some error occured " , {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
                 
        })
        
     }

      
    public render() {
        return (
            <React.Fragment>
                <div className="text-center"> Redirecting to home page </div>
                <ToastContainer
                    position="top-right"
                    autoClose={4000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    />
            </React.Fragment>
        );
    }
}

export default Logout;